module.exports = __webpack_public_path__ + "static/img/10019 (2).e2a097f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10019 (2).webp
// module id = m8F3
// module chunks = 14